import LoginIcon from './LoginIcon.jsx';
import LoginIconNew from './LoginIconNew.jsx';
import LogoutIcon from './LogoutIcon.jsx';
import OrdersIcon from './OrdersIcon.jsx';
import LocationIcon from './LocationIcon';
import AccountIcon from './AccountIcon';
import HelpIcon from './HelpIcon';
import NotificationIcon from './NotificationIcon';

export { LoginIcon, LogoutIcon, LoginIconNew, OrdersIcon, AccountIcon, LocationIcon, HelpIcon, NotificationIcon };


// WEBPACK FOOTER //
// ./src/icons/menu/index.jsx